import { render, staticRenderFns } from "../spots/spots.html?vue&type=template&id=47a6b468&scoped=true&external"
import script from "../spots/spots.js?vue&type=script&lang=js&external"
export * from "../spots/spots.js?vue&type=script&lang=js&external"
import style0 from "../spots/spots.css?vue&type=style&index=0&id=47a6b468&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a6b468",
  null
  
)

export default component.exports